import mapFunction from './mapResources';

export default mapFunction('employee_types', {
    isFetching: false,
    items: [] 
});
